import { Breakpoint } from '@mui/material';

type WidthOptions = 'Small' | 'Medium' | 'Large' | 'Extra_Large' | 'Full_Width';
export function formatSectionWidth(width: WidthOptions | undefined): Breakpoint {
  switch (width) {
    case 'Small':
      return 'sm';
    case 'Medium':
      return 'md';
    case 'Large':
      return 'lg';
    case 'Extra_Large':
      return 'xl';
    default:
      return 'xl';
  }
}
